import { createActionGroup, emptyProps, props } from '@ngrx/store';

import * as fromGenerated from '../../_generated';

export type AdminGroupsSortColumn = 'name' | 'teammates' | 'skills' | 'members';
export type AdminGroupsSortDirection = 'asc' | 'desc';

export const AdminGroupsActions = createActionGroup({
  source: 'AdminGroups',
  events: {
    'Load Groups': emptyProps(),
    'Load Groups Success': props<{ groups: fromGenerated.GroupView[] }>(),
    'Load Groups Failure': props<{ error: string }>(),

    'Set Sort': props<{
      column: AdminGroupsSortColumn | null;
      direction: AdminGroupsSortDirection;
    }>(),
    'Set Filter': props<{ filter: string }>(),

    'Open Create Modal': emptyProps(),
    'Open Edit Modal': props<{ group: fromGenerated.GroupView }>(),
    'Open Delete Confirm': props<{ group: fromGenerated.GroupView }>(),
    'Open Delete Confirm From Edit': props<{
      group: fromGenerated.GroupView;
    }>(),
    'Cancel Delete Confirm Return To Edit': emptyProps(),
    'Close Modal': emptyProps(),

    'Load Group Members Success': props<{
      members: fromGenerated.IdAndDisplayNameView[];
    }>(),
    'Load Group Members Failure': props<{ error: string }>(),

    // Lazy per-row expand payload for the table count-cell dropdowns.
    'Load Dropdown Payload': props<{ groupId: string }>(),
    'Load Dropdown Payload Success': props<{
      groupId: string;
      payload: fromGenerated.GroupDropdownPayloadView;
    }>(),
    'Load Dropdown Payload Failure': props<{
      groupId: string;
      error: string;
    }>(),

    'Create Group': props<{ name: string; memberIds: string[] }>(),
    'Create Group Success': props<{ group: fromGenerated.GroupView }>(),
    // The group was created but the follow-up add-members call failed. The row
    // still lands (with the members it does have); a warning toast tells the
    // user to reopen and add them. Distinct from Create Group Failure, where no
    // group exists on the server.
    'Create Group Members Failed': props<{ group: fromGenerated.GroupView }>(),
    'Create Group Failure': props<{ error: string }>(),

    'Update Group': props<{
      groupId: string;
      name?: string;
      addMembers: string[];
      removeMembers: string[];
    }>(),
    'Update Group Success': props<{ group: fromGenerated.GroupView }>(),
    'Update Group Failure': props<{ error: string }>(),

    'Delete Group': props<{ groupId: string }>(),
    'Delete Group Success': props<{ groupId: string }>(),
    'Delete Group Failure': props<{ error: string }>(),
  },
});
